import { getOrderRelatedSubscriptionBillingOptionById } from '../../order/selectors/subscriptions/get-order-related-subscription-billing-option-by-id';
import { isSubscriptionOrder } from '../../order/utils/order-type-utils';
import { getPaymentMethodsQueryForOrder } from '../utils/payment-methods-query';
import { getPaymentMethodsForQuery } from './get-payment-methods-for-query';
export const getPaymentMethodsForOrder = (order) => {
    const query = getPaymentMethodsQueryForOrder(order);
    const paymentMethods = getPaymentMethodsForQuery(query);
    if (!paymentMethods)
        return undefined;
    const isRecurringBillingRequired = isRecurringBillingRequiredForOrder(order);
    if (isRecurringBillingRequired)
        return paymentMethods.filter(method => method.isRecurringBillingSupported);
    return paymentMethods;
};
const isRecurringBillingRequiredForOrder = (order) => {
    if (!isSubscriptionOrder(order))
        return false;
    const billingOption = getBillingOptionForSubscriptionOrder(order);
    return billingOption.isRecurring;
};
const getBillingOptionForSubscriptionOrder = (order) => {
    if (!order.subscription)
        throw new Error('Cannot get billing option for Subscription order without subscription.');
    const billingOption = getOrderRelatedSubscriptionBillingOptionById(order.subscription.subscriptionBillingOptionId);
    if (!billingOption) {
        throw new Error(`Cannot find billing option with ID '${order.subscription.subscriptionBillingOptionId}'.`);
    }
    return billingOption;
};
